// icon:bx-atom | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Succes.png";

function IconBxSuccess(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Success"} />
	)
}

export default IconBxSuccess;
